import { t } from "@/i18n-js/instance";
import {
  dateFormats,
  formattedDateTime,
} from "@circle-react/helpers/dateTimeHelpers/formattedDateTime";

const SELECT_CONVERSATION_TYPE = "select-conversation-type";
export const uuid = () => new Date().getTime().toString();
export const timestamp = () =>
  formattedDateTime({
    dateTime: new Date(),
    format: dateFormats.short_time,
  });

export const buildChatPromptMessage = () => {
  const buttons = [
    {
      label: t(
        "support_widget.chatbot.templates.conversation_select_type_answers.question",
      ),
      event: SELECT_CONVERSATION_TYPE,
      value: "question",
    },
    {
      label: t(
        "support_widget.chatbot.templates.conversation_select_type_answers.bug",
      ),
      event: SELECT_CONVERSATION_TYPE,
      value: "bug",
    },
  ];

  return {
    content: t("support_widget.chatbot.templates.conversation_select_type"),
    buttons,
  };
};
